/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const challengeNeedingAudioItemSchema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
});

export const challengesNeedingAudioV1DataSchema = z.object({
  items: z.array(challengeNeedingAudioItemSchema),
  remaining: z.number(),
});

export type IChallengeNeedingAudioItem = z.infer<typeof challengeNeedingAudioItemSchema>;
export type IChallengesNeedingAudioV1Data = z.infer<typeof challengesNeedingAudioV1DataSchema>;

export const getChallengesNeedingAudioV1ResponseSchema = createApiResponseSchema(
  challengesNeedingAudioV1DataSchema,
) as z.ZodSchema<IAPI<IChallengesNeedingAudioV1Data>>;

export type IGetChallengesNeedingAudioV1Response = IAPI<IChallengesNeedingAudioV1Data>;
